import React from 'react'
import PropTypes from 'prop-types'
import { partial, isFunction, isString, isNull } from 'lodash-es'
import CopyToClipboard from 'react-copy-to-clipboard'
import classNames from 'classnames'

import './ClipboardButtonComponent.scss'

class ClipboardButtonComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      textCopied: false,
    }

    this.timeoutId = 0
    this.onTextCopied = this.onTextCopied.bind(this)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { text } = this.props

    if (nextProps.text !== text) {
      this.setState({ textCopied: false })
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.timeoutId)
  }

  onTextCopied(onCopy) {
    const { textCopied } = this.state
    // don't allow coping the link again until the message is visible and the state is not change back
    if (textCopied) {
      return
    }

    window.clearTimeout(this.timeoutId)

    this.timeoutId = window.setTimeout(() => {
      this.setState({ textCopied: false })
    }, 2000)

    if (isFunction(onCopy)) {
      this.setState({ textCopied: true })
      onCopy()
    }
  }

  render() {
    const { textCopied } = this.state
    const { text, title, onCopy, disabled, children, hideIcon } = this.props
    const className = classNames('clipboard-button-component', {
      'clipboard-button-copied': textCopied,
      'hide-icon': hideIcon,
      disabled,
    })

    return (
      <CopyToClipboard text={text} onCopy={partial(this.onTextCopied, onCopy)}>
        {!isNull(children) ? (
          children
        ) : (
          <button
            type="button"
            disabled={disabled}
            className={className}
            {...(isString(title) && { title })}
          >
            {hideIcon ? title : null}
          </button>
        )}
      </CopyToClipboard>
    )
  }
}

ClipboardButtonComponent.propTypes = {
  text: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  hideIcon: PropTypes.bool,
  onCopy: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
}

ClipboardButtonComponent.defaultProps = {
  text: '',
  disabled: false,
  children: null,
  title: 'Copy to clipboard',
}

export default ClipboardButtonComponent
